import React from "react";
import IncSiteForm from "./inc_site_form";

const CreateIncSite: React.FC = () => {
  return <IncSiteForm mode="create" />;
};

export default CreateIncSite;
